'use strict';

// src/error/http-error-code.ts
var HttpErrorCode = /* @__PURE__ */ ((HttpErrorCode2) => {
  HttpErrorCode2["MISSING_PARAMS"] = "MISSING_PARAMS";
  HttpErrorCode2["NOT_FOUND"] = "NOT_FOUND";
  HttpErrorCode2["WRONG_PASSWORD"] = "WRONG_PASSWORD";
  HttpErrorCode2["FORBIDDEN"] = "FORBIDDEN";
  HttpErrorCode2["UNAUTHORIZED"] = "UNAUTHORIZED";
  HttpErrorCode2["INVALID"] = "INVALID";
  HttpErrorCode2["UNPROCESSABLE_ENTITY"] = "UNPROCESSABLE_ENTITY";
  HttpErrorCode2["ALREADY_EXISTS"] = "ALREADY_EXISTS";
  HttpErrorCode2["UNKNOWN"] = "UNKNOWN";
  HttpErrorCode2["INVALID_CONTENT"] = "INVALID_CONTENT";
  HttpErrorCode2["LIMIT_EXCEEDED"] = "LIMIT_EXCEEDED";
  return HttpErrorCode2;
})(HttpErrorCode || {});

exports.HttpErrorCode = HttpErrorCode;
